import React, { useState, useEffect } from "react";
import "./TypeaheadInput.css";
import SearchIcon from "assets/icons/search-icon.svg";
import { placeholder } from "@babel/types";

function TypeaheadInput({
  options,
  selectedOption,
  handleSelectOption,
  placeHolder,
}) {
  const [userInput, setUserInput] = useState(selectedOption);
  const [suggestions, setSuggestions] = useState([]);
  const [isFocused, setIsFocused] = useState(false);

  const [popularChoices, setPopularChoices] = useState([]);

  useEffect(() => {
    // Select 3 random options as popular choices
    setPopularChoices(options.sort(() => 0.5 - Math.random()).slice(0, 5));
  }, [options]);

  useEffect(() => {
    setUserInput(selectedOption);
  }, [selectedOption]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setUserInput(value);

    const filteredSuggestions = options.filter((option) =>
      option.toLowerCase().includes(value.toLowerCase())
    );
    setSuggestions(filteredSuggestions);
  };

  const handleSuggestionClick = (suggestion) => {
    handleSelectOption(suggestion);
    setUserInput(suggestion);
    setSuggestions([]);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className="typeahead-container">
      <div className="input-container">
        <div className={`typeahead-input ${isFocused ? "focused" : ""}`}>
          {/* Use the locally sourced SVG */}
          <img src={SearchIcon} className="search-icon" alt="Search" />
          <input
            type="text"
            value={userInput}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onChange={handleInputChange}
            placeholder={placeHolder}
          />
        </div>
        <div className="suggestions-list-container">
          {suggestions.length > 0 && (
            <div className="suggestions-list">
              {suggestions.map((suggestion, index) => (
                <div
                  className="suggestion-item"
                  key={index}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  {/* Split the suggestion into parts and apply <strong> to matched parts */}
                  {suggestion
                    .split(new RegExp(`(${userInput})`, "gi"))
                    .map((part, index) =>
                      part.toLowerCase() === userInput.toLowerCase() ? (
                        <span key={index}>{part}</span>
                      ) : (
                        part
                      )
                    )}
                </div>
              ))}
            </div>
          )}
        </div>
        <p className="popular-choices-title">Popular topics</p>
        {popularChoices.length > 0 && (
          <div className="popular-choices">
            {popularChoices.map((choice, index) => (
              <a
                key={index}
                className="popular-choice"
                onClick={() => handleSelectOption(choice)}
              >
                {choice}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default TypeaheadInput;
